export default __webpack_public_path__ + "static/media/aluxus_1.6b740961.jpg";